import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ReplicateInformationErrors } from '../models/replicate-information-errors';
import { Paging } from '../models/page';
import { ResponseModel } from '../models/response-model';
import { Observable } from 'rxjs';
import { Filter } from '../models/filter';
import { ReplicateInformationFilter } from '../models/filters/replicate-information-filter';
import { ReplicateInformationLog } from '../models/replication-information-log';
import { ReplicateInformation } from '../models/replicate-information';

@Injectable({
  providedIn: 'root'
})
export class ReplicateInformationService {

  private url = `${environment.url}/replicateInformation`;
  constructor(private http: HttpClient) { }

  readReplicateInformationLog(replicateInfoFilter: Filter<ReplicateInformationFilter>): Observable<ResponseModel<Paging<Array<ReplicateInformationErrors>>>> {
    let params = new HttpParams();
    params = params
      .set("page", replicateInfoFilter.page.toString())
      .set("pageSize", replicateInfoFilter.pageSize.toString());

    params = replicateInfoFilter.value.status ? params.append("status", replicateInfoFilter.value.status) : params;
    params = replicateInfoFilter.value.destination ? params.append("destination", replicateInfoFilter.value.destination) : params;
    params = replicateInfoFilter.value.id ? params.append("id", replicateInfoFilter.value.id) : params;
    params = replicateInfoFilter.value.collection ? params.append("collection", replicateInfoFilter.value.collection) : params;
    params = replicateInfoFilter.value.errorType ? params.append("errorType", replicateInfoFilter.value.errorType) : params;
    params = replicateInfoFilter.value.sellerCode ? params.append("sellerCode", replicateInfoFilter.value.sellerCode) : params;
    params = replicateInfoFilter.value.customerCode ? params.append("customerCode", replicateInfoFilter.value.customerCode) : params;
    params = replicateInfoFilter.value.branchCode ? params.append("branchCode", replicateInfoFilter.value.branchCode) : params;
    params = replicateInfoFilter.value.SalesOrgCode ? params.append("SalesOrgCode", replicateInfoFilter.value.SalesOrgCode) : params;
    params = replicateInfoFilter.value.startDate ? params.append("startDate", replicateInfoFilter.value.startDate) : params;
    params = replicateInfoFilter.value.endDate ? params.append("endDate", replicateInfoFilter.value.endDate) : params;

    return this.http.get<ResponseModel<Paging<Array<ReplicateInformationErrors>>>>(this.url, { params });
  }

  readReplicateInformationByCode(code: string): Observable<ResponseModel<ReplicateInformation>> {
    return this.http.get<ResponseModel<ReplicateInformation>>(`${this.url}/${code}`);
  }
  readReplicateInformationLogByCode(code: string): Observable<ResponseModel<Paging<Array<ReplicateInformationLog>>>> {
    return this.http.get<ResponseModel<Paging<Array<ReplicateInformationLog>>>>(`${this.url}/${code}/log`);
  }
  resendReplicateTransaction(_id: string) {
    let params = new HttpParams();
    params = params.set("replicateInformationId", _id);

    return this.http.post<ResponseModel<any>>(`${this.url}/resend`, {}, { params });
  }
}
